var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPackageIcon = function SvgPackageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163,
    height: 164,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A6B3BA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M81.5 149.596c-5.529 0-10.815-2.231-21.38-6.692-26.302-11.113-39.456-16.676-39.456-26.024V48.202M81.5 149.596c5.53 0 10.816-2.231 21.381-6.692 26.301-11.113 39.456-16.676 39.456-26.024V48.202M81.5 149.596V77.64M40.943 82l13.519 6.76m60.836-60.836L47.702 61.72m8.964 4.671L36.92 56.841c-10.836-5.245-16.257-7.868-16.257-12.019s5.421-6.773 16.257-12.018l19.738-9.551c12.2-5.901 18.285-8.849 24.841-8.849s12.647 2.948 24.835 8.849l19.745 9.55c10.835 5.246 16.257 7.869 16.257 12.02s-5.422 6.773-16.257 12.018l-19.738 9.551c-12.201 5.901-18.285 8.849-24.842 8.849s-12.647-2.948-24.834-8.849"
  })));
};
export default SvgPackageIcon;